



























import {Vue, Component, Prop} from 'vue-property-decorator';
import {ResumeContent} from './resume.d';

@Component({
  name: 'resumeSectionItem',
})
export default class ResumeSectionItem extends Vue {
  @Prop() private content: ResumeContent[];
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/about/resume-section-item.vue